import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useConfigurator, WIZARD_STEPS } from '../../store/configurator';
import { CountrySelector } from '../../country/CountrySelector';
import { MobileLoader } from '../components/MobileLoader';
import { MobileThemeFlow } from '../flows/MobileThemeFlow';
import { MobileColorsFlow } from '../flows/MobileColorsFlow';
import { MobileReviewFlow } from '../flows/MobileReviewFlow';
import { MobilePaymentFlow } from '../flows/MobilePaymentFlow';
import { ErrorScreen, ErrorText } from './MobileApp.styles';

/**
 * Mobile experience root — the dedicated phone-width wizard for the v0 flow. Sub-steps
 * inside each flow are LOCAL state; the four top-level steps map to the wizard's URL
 * (theme / colors / review / payment), matching how the desktop steps are routed.
 */
export const MobileApp = (): React.ReactElement => {
  const { status } = useConfigurator();
  const location = useLocation();
  // Skip pressed during loading → jump straight past the intro animation.
  const [skipIntro, setSkipIntro] = useState(false);

  // Which top-level step the current URL points at (defaults to theme).
  const stepKey = WIZARD_STEPS.find((s) => location.pathname.startsWith(s.path))?.key ?? 'theme';

  if (status === 'loading') {
    return <MobileLoader onSkip={() => setSkipIntro(true)} />;
  }

  if (status === 'error') {
    return (
      <ErrorScreen>
        <ErrorText text="Couldn’t load the configurator. Please try again." tag="paragraph" />
      </ErrorScreen>
    );
  }

  return (
    <>
      {stepKey === 'colors' ? (
        <MobileColorsFlow />
      ) : stepKey === 'review' ? (
        <MobileReviewFlow />
      ) : stepKey === 'payment' ? (
        <MobilePaymentFlow />
      ) : (
        <MobileThemeFlow skipIntro={skipIntro} />
      )}
      <CountrySelector />
    </>
  );
};

export default MobileApp;
